
import { CommandType } from "~app/common/services/cqs/CommandType";
import { AvtalCommandBase } from "./AvtalCommandBase";

export class UpdateAvtalKundKontaktpersonCommand extends AvtalCommandBase {
    KontaktpersonId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAvtalKundKontaktpersonCommand";

    constructor(avtalGuid: string, kontaktpersonId: number) {
        super(avtalGuid, UpdateAvtalKundKontaktpersonCommand.$type, CommandType.Replace);
        this.KontaktpersonId = kontaktpersonId;
    }
}
